import { BxEditorConfig } from '@buildxact/ui-components/bx-editor';

export interface BxEditorConfigBase extends BxEditorConfig {
    licenseKey: string;
}

export const BxEditorBase: BxEditorConfigBase = {
    licenseKey: 'SXhDdDZzSkZzOGxuZmw3b09MUWZXcVNnd0orYSsrNDgxeVlkUmpSWWVhdjYrM2I5aHJ2RndmUT0tTWpBeU5UQTVNVFE9',
};
